import React from "react";
import { withLocalize } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import BbInput from "../../styling/bbInput";
import PopupMultiSelectButton from "../../common/popupMultiSelectButton";
import { domainActions } from '../../../store/domainStore';
import { isNullOrUndefined } from "../../../store/storeFunctions";
import SelectOption from '../../searchSections/selectOption';
import { selectDefaultStyles } from '../../styling/selectDefaultStyles';

class Vehicles extends React.Component {
    render() {
        return (
            <>
                <BbInput type='custom' label={this.props.translate('Search.Marketing.Vehicles.Category')} placeholder={{ type: 'column' }} custom={
                    <PopupMultiSelectButton
                        title={this.props.translate("Search.Marketing.Vehicles.Category")}
                        data='vehicle-categories'
                        name='vehicle-categories'
                        popupSize='large'
                        onClick={() => this.props.ensureDomainData('vehicle-categories')}
                        selection={this.props.formik.values.vehicles.categories}
                        handleChange={(all, parent) => {
                            this.checkIfAll("vehicle-categories", "vehicles.categories", all.length)
                            this.props.formik.setFieldValue('vehicles.categories.all', all);
                            this.props.formik.setFieldValue('vehicles.categories.parent', parent);
                        }}
                    />
                } />
                <BbInput type='radio' label={this.props.translate('Search.Marketing.Vehicles.Status')} placeholder={{ type: 'column' }}
                    options={[
                        { value: "0", label: 'Common.DoesNotMatter' },
                        { value: "new", label: 'Search.Marketing.Vehicles.Status.New' },
                        { value: "used", label: 'Search.Marketing.Vehicles.Status.Used' }
                    ]} idFormat={(val) => `$radio-${this.props.field}-status-${val}`}
                    checkedValue={this.getValue(this.props.formik.values.vehicles.status, "0")}
                    callback={(val) => this.props.formik.setFieldValue(`vehicles.status`, val)}
                />
                <BbInput type='select-noformik' label={this.props.translate('Search.Marketing.Vehicles.RegistrationDate')}
                    placeholder={{ type: 'column' }}
                    options={this.getYearOptions()} formatOptionLabel={SelectOption}
                    onChange={(e) => this.props.formik.setFieldValue("vehicles.registration", e.value)}
                    value={this.getYearOption(this.props.formik.values.vehicles.registration)}
                    styles={selectDefaultStyles}
                />
                <BbInput type='select-noformik' label={this.props.translate('Search.Marketing.Vehicles.RegistrationCrDate')}
                    placeholder={{ type: 'column' }}
                    options={this.getYearOptions()} formatOptionLabel={SelectOption}
                    onChange={(e) => this.props.formik.setFieldValue("vehicles.registrationCr", e.value)}
                    value={this.getYearOption(this.props.formik.values.vehicles.registrationCr)}
                    styles={selectDefaultStyles}
                />
                <BbInput type='select-noformik' label={this.props.translate('Search.Marketing.Vehicles.DeRegistrationDate')}
                    placeholder={{ type: 'column' }}
                    options={this.getYearOptions()} formatOptionLabel={SelectOption}
                    onChange={(e) => this.props.formik.setFieldValue("vehicles.deRegistration", e.value)}
                    value={this.getYearOption(this.props.formik.values.vehicles.deRegistration)}
                    styles={selectDefaultStyles}
                />
                <BbInput type='radio' label={this.props.translate('Search.Marketing.Vehicles.FinancialLeasing')} placeholder={{ type: 'column' }}
                    options={[
                        { value: "0", label: 'Common.DoesNotMatter' },
                        { value: "yes", label: 'Common.Yes' },
                        { value: "no", label: 'Common.No' }
                    ]} idFormat={(val) => `$radio-${this.props.field}-leasing-${val}`}
                    checkedValue={this.getValue(this.props.formik.values.vehicles.leasing, "0")}
                    callback={(val) => this.props.formik.setFieldValue(`vehicles.leasing`, val)}
                />
            </>
        )
    }

    checkIfAll(domain, field, length) {
        if (this.props.hasOwnProperty(domain) && this.props[domain].requestResult.length === length) {
            this.props.formik.setFieldValue(`${field}.allSelected`, true);
            return true;
        }
        this.props.formik.setFieldValue(`${field}.allSelected`, false);
        return false;
    }

    getValue(value, defaultValue) {
        return (isNullOrUndefined(value) || value === "") ? defaultValue : value;
    }

    getYearOption(year) {
        if (year === 1900)
            return { value: 1900, key: 1900, label: `${this.props.translate("Search.Marketing.Vehicles.OlderThan")} 2014` }
        else
            return { key: year, value: year, label: `${this.props.translate("Search.Marketing.Vehicles.NotOlderThan")} ${year}` };
    }

    getYearOptions() {
        let options = [];
        for (let i = new Date().getFullYear() - 1; i >= 2014; i--)
            options.push(this.getYearOption(i));
        options.push(this.getYearOption(1900));
        return options;
    }

}

export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(connectFormik(Vehicles)));



